<template >
  <van-list
    v-model="loading"
    :finished="finished"
    @load="checkSearch"
    :immediate-check="false"
  >
    <van-icon
      slot="right-icon"
      name="search"
      class="van-cell__right-icon"
    />
    <template v-for="item in list">
      <customer-list-cell
        v-bind:item="item"
        v-bind:key="item.id"
        @click.native="customerDetail(item.id)"
      ></customer-list-cell>
    </template>
  </van-list>

</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { List, Cell, Icon } from 'vant'
import CustomerListCell from './CustomerListCell'
import request from '@/utils/request'

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    CustomerListCell
  },
  name: 'CustomerList',
  props: {
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      nextPage: 1,
      loading: false,
      finished: false
    }
  },
  methods: {
    generateCustomizeString,
    customerDetail(customerId) {
      this.$router.push({
        name: 'CustomerDetail',
        params: { customerId: customerId }
      })
    },
    fetchDataUseKeyword(keyword) {
      this.finished = false
      this.list = []
      const url1 = '/customer-list?phone=' + keyword
      const url2 = '/customer-list?wx_nickname=' + keyword
      this.fetchData(url1)
      this.fetchData(url2)
    },
    fetchData(url) {
      if (this.finished === true) {
        return
      }
      this.loading = true
      request({
        url: url,
        method: 'get',
        params: {
          page: this.nextPage,
          page_size: 8
        }
      })
        .then(response => {
          const data = response.data
          // const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.memberId = response.data[i].id
            obj.username = response.data[i].phone
            obj.remark = response.data[i].remark
            obj.registrationDate = response.data[i].created_at
            if (
              response.data[i].wechat_auths.length &&
              response.data[i].wechat_auths[0].user_info
            ) {
              obj.headimgurl =
                response.data[i].wechat_auths[0].user_info['headimgurl']
              obj.wechatName =
                response.data[i].wechat_auths[0].user_info['nickname']
            } else {
              obj.wechatName = this.generateCustomizeString('none')
            }
            if (response.data[i].credits) {
              obj.creditId = response.data[i].credits.id
              obj.memberCredit =
                'NZD $' +
                parseFloat(response.data[i].credits.credits / 100).toFixed(2)
            } else {
              obj.memberCredit = 'NZD $0.00'
            }
            if (response.data[i].points) {
              if (response.data[i].points.level_info) {
                obj.memberLevel = response.data[i].points.level_info.name
              } else {
                obj.memberLevel = this.generateCustomizeString('none')
              }
              obj.memberPoint = response.data[i].points.points
              obj.totleAmount =
                'NZD $' +
                parseFloat(response.data[i].points.total_cost / 100).toFixed(2)
            } else {
              obj.memberLevel = this.generateCustomizeString('none')
              obj.memberPoint = '0'
              obj.totleAmount = 'NZD $0.00'
            }

            data[i] = obj
          }
          this.list = this.list.concat(data)
          this.loading = false
          if (response.meta.current_page === response.meta.last_page) {
            this.finished = true
          } else {
            this.nextPage = response.meta.current_page + 1
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },
    checkSearch() {
      if (!this.isSearch) {
        var url = '/customer-list'
        this.fetchData(url)
      }
    }
  },
  created: function() {
    this.checkSearch()
  }
}
</script>

<style>
</style>
